import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiHighlightModule } from '@fi-shared/highlight';
import { FiInputKeyboardNavigationModule } from '@fi-shared/fi-directives/input-keyboard-navigation';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, FiHighlightModule, FiInputKeyboardNavigationModule],
    declarations: [],
    exports: [FiAppTextSharedModule, FiHighlightModule, FiInputKeyboardNavigationModule],
})
export class UtilitiesCommonModule {}
